module.exports = "https://milano-network.servercdn.it/static/img/story2.jpg?76733d5e3d3a41a724d7f707e6723bdf";